<template>
  <b-navbar-brand :href="cityWebsite" target="__blank">
    <img id="city_logo" :src="logoLink" class="align-top" alt="Logo" />
    <div id="city_name" class="align-top">{{ cityName }}</div>
  </b-navbar-brand>
</template>

<script>
export default {
  name: 'app-navbar-brand',
  props: {
    cityName: String,
    cityWebsite: String,
    logoLink: String
  }
}
</script>

<style scoped>
.navbar-brand {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 10rem;
  max-width: 15rem;
  white-space: pre-wrap;
}

#city_name {
  padding-left: 1rem;
  font-size: 0.8rem;
}

#city_logo {
  height: 3rem;
  padding-left: 1rem;
  filter: drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.9));
}

@media (min-width: 768px) {
  .navbar-brand {
    padding: 0;
    min-width: 20rem;
    max-width: 20rem;
    white-space: pre-wrap;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 100%;
  }

  #city_name {
    font-size: 0.8rem;
    padding-left: 1rem;
  }

#city_logo {
  height: 4rem;
}

  .user_infos {
    width: 15rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navbar/app-navbar-brand.vue